import React, { Suspense, lazy } from 'react'
import ScrollToTop from "../hooks/ScrollToTop";
import UserLayout from "./UserLayout";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from "../pages/home/Home"
// import Calendar from "../pages/Calendar/Calendar";
// import SectorD from "../pages/SectorD/Home";
import BranchGuard from "../hooks/BranchGuard";
import Founder from '../pages/Founder/Founder';

const loadPage = (clientLoader, serverPath) => {
  if (typeof window === "undefined") {
    const serverRequire = module.require.bind(module);
    const loadedModule = serverRequire(serverPath);
    return loadedModule.default || loadedModule;
  }

  return lazy(clientLoader);
};

const Contact = loadPage(() => import("../pages/contact/Contact"), "../pages/contact/Contact");
const Blog = loadPage(() => import("../pages/blog/Blog"), "../pages/blog/Blog");
const BlogDetail = loadPage(() => import("../pages/blogdetail/BlogDetail"), "../pages/blogdetail/BlogDetail");
const Error = loadPage(() => import("../pages/404/Error"), "../pages/404/Error");
const Thankyou = loadPage(() => import("../pages/thankyou/Thankyou"), "../pages/thankyou/Thankyou");
const AdmissionProcess = loadPage(() => import("../pages/AdmissionProcess/AdmissionProcess"), "../pages/AdmissionProcess/AdmissionProcess");
const FeeStructure = loadPage(() => import("../pages/FeeStructure/FeeStructure"), "../pages/FeeStructure/FeeStructure");
const BursariesScholarships = loadPage(() => import("../pages/BursariesScholarships/BursariesScholarships"), "../pages/BursariesScholarships/BursariesScholarships");
const ApplyNow = loadPage(() => import("../pages/ApplyNow/ApplyNow"), "../pages/ApplyNow/ApplyNow");
const ApplyNowSectorD = loadPage(() => import("../pages/ApplyNowSectorD/ApplyNow"), "../pages/ApplyNowSectorD/ApplyNow");
const ScheduleVisit = loadPage(() => import("../pages/ScheduleVisit/ScheduleVisit"), "../pages/ScheduleVisit/ScheduleVisit");
const FoundationYear = loadPage(() => import("../pages/FoundationYear/FoundationYear"), "../pages/FoundationYear/FoundationYear");
const Preparatory = loadPage(() => import("../pages/Preparatory/Preparatory"), "../pages/Preparatory/Preparatory");
const MedicalSupport = loadPage(() => import("../pages/MedicalSupport/MedicalSupport"), "../pages/MedicalSupport/MedicalSupport");
const Safeguarding = loadPage(() => import("../pages/Safeguarding/Safeguarding"), "../pages/Safeguarding/Safeguarding");
const Refectory = loadPage(() => import("../pages/Refectory/Refectory"), "../pages/Refectory/Refectory");
const LearningSupport = loadPage(() => import("../pages/LearningSupport/LearningSupport"), "../pages/LearningSupport/LearningSupport");
const Student = loadPage(() => import("../pages/Student/Student"), "../pages/Student/Student");
const Teacher = loadPage(() => import("../pages/Teacher/Teacher"), "../pages/Teacher/Teacher");
const Parents = loadPage(() => import("../pages/Parents/Parents"), "../pages/Parents/Parents");
const Alumni = loadPage(() => import("../pages/Alumni/Alumni"), "../pages/Alumni/Alumni");
const News = loadPage(() => import("../pages/News/News"), "../pages/News/News");
const NewsDetail = loadPage(() => import("../pages/NewsDetail/NewsDetail"), "../pages/NewsDetail/NewsDetail");
const MakingDifference = loadPage(() => import("../pages/MakingDifference/MakingDifference"), "../pages/MakingDifference/MakingDifference");
const Sport = loadPage(() => import("../pages/Sport/Sport"), "../pages/Sport/Sport");
const Drama = loadPage(() => import("../pages/Drama/Drama"), "../pages/Drama/Drama");
const Music = loadPage(() => import("../pages/Music/Music"), "../pages/Music/Music");
const Adventure = loadPage(() => import("../pages/Adventure/Adventure"), "../pages/Adventure/Adventure");
const ActivitiesWeek = loadPage(() => import("../pages/ActivitiesWeek/ActivitiesWeek"), "../pages/ActivitiesWeek/ActivitiesWeek");
const Societies = loadPage(() => import("../pages/Societies/Societies"), "../pages/Societies/Societies");
const Leadership = loadPage(() => import("../pages/Leadership/Leadership"), "../pages/Leadership/Leadership");
const Service = loadPage(() => import("../pages/Service/Service"), "../pages/Service/Service");
const AcademicEthos = loadPage(() => import("../pages/AcademicEthos/AcademicEthos"), "../pages/AcademicEthos/AcademicEthos");
const Montessori = loadPage(() => import("../pages/Montessori/Montessori"), "../pages/Montessori/Montessori");
const Libraries = loadPage(() => import("../pages/Libraries/Libraries"), "../pages/Libraries/Libraries");
const Career = loadPage(() => import("../pages/Career/Career"), "../pages/Career/Career");
const PreSchool = loadPage(() => import("../pages/PreSchool/PreSchool"), "../pages/PreSchool/PreSchool");
const Senior = loadPage(() => import("../pages/Senior/Senior"), "../pages/Senior/Senior");
const Primary = loadPage(() => import("../pages/Primary/Primary"), "../pages/Primary/Primary");
const PlaySchool = loadPage(() => import("../pages/PlaySchool/PlaySchool"), "../pages/PlaySchool/PlaySchool");
const AcademicDepartment = loadPage(() => import("../pages/AcademicDepartment/AcademicDepartment"), "../pages/AcademicDepartment/AcademicDepartment");
const AcademicDetail = loadPage(() => import("../pages/AcademicDetail/AcademicDetail"), "../pages/AcademicDetail/AcademicDetail");
const Principal = loadPage(() => import("../pages/Principal/Principal"), "../pages/Principal/Principal");
const Chairman = loadPage(() => import("../pages/Chairman/Chairman"), "../pages/Chairman/Chairman");
const Aims = loadPage(() => import("../pages/Aims/Aims"), "../pages/Aims/Aims");
const AccreditionAffilation = loadPage(() => import("../pages/AccreditionAffilation/AccreditionAffilation"), "../pages/AccreditionAffilation/AccreditionAffilation");
const History = loadPage(() => import("../pages/History/History"), "../pages/History/History");
const TeachingStaff = loadPage(() => import("../pages/TeachingStaff/TeachingStaff"), "../pages/TeachingStaff/TeachingStaff");
const WhyLps = loadPage(() => import("../pages/WhyLps/WhyLps"), "../pages/WhyLps/WhyLps");
const Stories = loadPage(() => import("../pages/Stories/Stories"), "../pages/Stories/Stories");
const TermsCondition = loadPage(() => import("../pages/TermsCondition/TermsCondition"), "../pages/TermsCondition/TermsCondition");
const PrivacyPolicy = loadPage(() => import("../pages/PrivacyPolicy/PrivacyPolicy"), "../pages/PrivacyPolicy/PrivacyPolicy");
const LegalStatement = loadPage(() => import("../pages/LegalStatement/LegalStatement"), "../pages/LegalStatement/LegalStatement");
const Cookies = loadPage(() => import("../pages/Cookies/Cookies"), "../pages/Cookies/Cookies");
const ManagerSectorD = loadPage(() => import("../pages/ManagerSectorD/ManagerSectorD"), "../pages/ManagerSectorD/ManagerSectorD");
const PrincipalSectorD = loadPage(() => import("../pages/PrincipalSectorD/PrincipalSectorD"), "../pages/PrincipalSectorD/PrincipalSectorD");
const AdmissionSectorD = loadPage(() => import("../pages/AdmissionSectorD/AdmissionSectorD"), "../pages/AdmissionSectorD/AdmissionSectorD");
const Values = loadPage(() => import("../pages/Value/Values"), "../pages/Value/Values");
const Lucknow = loadPage(() => import("../pages/Lucknow/Lucknow"), "../pages/Lucknow/Lucknow");
const Unnao = loadPage(() => import("../pages/Unnao/Unnao"), "../pages/Unnao/Unnao");
const Raebareli = loadPage(() => import("../pages/Raebareli/Raebareli"), "../pages/Raebareli/Raebareli");
const DirectorSectorD = loadPage(() => import("../pages/DirectorSectorD/DirectorSectorD"), "../pages/DirectorSectorD/DirectorSectorD");
const Dynamic = loadPage(() => import("../pages/Dynamic/Dynamic"), "../pages/Dynamic/Dynamic");
const NewBooksList = loadPage(() => import("../pages/newbookslist/NewBooksList"), "../pages/newbookslist/NewBooksList");
const Disclosure = loadPage(() => import("../pages/Disclosure/Disclosure"), "../pages/Disclosure/Disclosure");


export default function NavRouter({initialData}) {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<UserLayout initialData={initialData} />}>
          <Route index element={<Home initialData={initialData}/>} />
          <Route path="contact" element={<Contact initialData={initialData}/>} />
          <Route path="blog" element={<Blog initialData={initialData}/>} />
          <Route path="blog/:blog_slug" element={<BlogDetail initialData={initialData}/>} />
          <Route path="admission-process" element={<AdmissionProcess />} />

          <Route path=":branch_name/admission-process" element={<BranchGuard><AdmissionSectorD /></BranchGuard>} />
          <Route path=":branch_name/fee-structure" element={<BranchGuard><FeeStructure /></BranchGuard>} />
          <Route path=":branch_name/book-list" element={<BranchGuard><NewBooksList /></BranchGuard>} />
          <Route path=":branch_name/bursaries-and-scholarship" element={<BranchGuard><BursariesScholarships /></BranchGuard>} />
          <Route path=":branch_name/schedule-a-visit" element={<BranchGuard><ScheduleVisit /></BranchGuard>} />
          <Route path=":branch_name/apply-now" element={<BranchGuard><ApplyNow /></BranchGuard>} />
          <Route path="apply-now" element={<ApplyNowSectorD />} />

          <Route path="learning-pathway-foundation" element={<FoundationYear />} />
          <Route path=":branch_name/learning-pathway-preparatory" element={<BranchGuard><Preparatory /></BranchGuard>} />
          <Route path="learning-support" element={<LearningSupport />} />
          <Route path="medical-support" element={<MedicalSupport />} />
          <Route path="safeguarding" element={<Safeguarding />} />
          <Route path="refectory" element={<Refectory />} />
          <Route path="student" element={<Student />} />
          <Route path="teacher" element={<Teacher />} />
          <Route path="parents" element={<Parents />} />
          <Route path="alumni" element={<Alumni />} />
          <Route path="news" element={<News initialData={initialData}/>} />
          <Route path="news/:news_slug" element={<NewsDetail initialData={initialData}/>} />
          <Route path="making-a-difference" element={<MakingDifference />} />
          <Route path="sport" element={<Sport />} />
          <Route path="drama" element={<Drama />} />
          <Route path="music" element={<Music />} />
          <Route path="adventure" element={<Adventure />} />
          <Route path="activities-week" element={<ActivitiesWeek />} />
          <Route path="societies" element={<Societies />} />
          <Route path="leadership" element={<Leadership />} />
          <Route path="service" element={<Service />} />

          <Route path="montessori" element={<Montessori />} />
          <Route path=":branch_name/academic-ethos" element={<BranchGuard><AcademicEthos /></BranchGuard>} />
          <Route path=":branch_name/the-libraries" element={<BranchGuard><Libraries /></BranchGuard>} />
          <Route path=":branch_name/career" element={<BranchGuard><Career /></BranchGuard>} />
          <Route path=":branch_name/junior" element={<BranchGuard><PreSchool /></BranchGuard>} />
          <Route path=":branch_name/senior" element={<BranchGuard><Senior /></BranchGuard>} />
          <Route path=":branch_name/pre-primary" element={<BranchGuard><Primary /></BranchGuard>} />
          <Route path=":branch_name/primary" element={<BranchGuard><PlaySchool /></BranchGuard>} />
          <Route path=":branch_name/academic-department" element={<BranchGuard><AcademicDepartment /></BranchGuard>} />
          <Route path=":branch_name/academic-detail/:subject_slug" element={<BranchGuard><AcademicDetail /></BranchGuard>} />

          {/* <Route path="Calendar" element={<Calendar/>} /> */}
          <Route path="manager-desk" element={<Principal />} />
          <Route path="director-desk" element={<Chairman />} />
          <Route path="founder-desk" element={<Founder />} />
          <Route path="our-aim" element={<Aims />} />
          <Route path="accreditation-and-affiliation" element={<AccreditionAffilation />} />
          <Route path="our-heritage" element={<History />} />
          <Route path=":branch_name/teaching-staff" element={<BranchGuard><TeachingStaff /></BranchGuard>} />
          <Route path="why-lps-lucknow-public-school" element={<WhyLps />} />
          <Route path="stories" element={<Stories />} />
          <Route path="terms-and-condition" element={<TermsCondition />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="legal-statement" element={<LegalStatement />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path=":branch_name/manager-desk" element={<BranchGuard> <ManagerSectorD /></BranchGuard>} />
          <Route path=":branch_name/principal-desk" element={<BranchGuard><PrincipalSectorD /></BranchGuard>} />
          <Route path=":branch_name/director-desk" element={<BranchGuard><DirectorSectorD /></BranchGuard>} />
          <Route path="values" element={<Values />} />
          <Route path="/:branch_slug/disclosure" element={<Disclosure initialData={initialData}/>} />

          <Route path="/:branch_name"
            element={
              (() => {
                const branch = location.pathname.split("/")[1];

                const validBranches = [
                  "lps-school-unnao-sector-b",
                  "lps-school-unnao-sector-c",
                  "lps-school-pragatipuram",
                  "lps-school-ahiyaraipur",
                  "lps-school-sector-d",
                  "lps-school-sector-i",
                  "lps-school-jankipuram",
                  "lps-school-south-city",
                  "lps-school-eldeco",
                  "lps-school-ansal",
                ];

                if (!validBranches.includes(branch)) {
                  return <Dynamic initialData={initialData}/>;
                }

                if (
                  ["lps-school-unnao-sector-b", "lps-school-unnao-sector-c"].includes(branch)
                ) {
                  return <Unnao initialData={initialData}/>;
                }

                if (
                  ["lps-school-pragatipuram", "lps-school-ahiyaraipur"].includes(branch)
                ) {
                  return <Raebareli initialData={initialData}/>;
                }

                return <Lucknow initialData={initialData}/>;
              })()
            }
          />
        </Route>

        {/* Routes without footer*/}
        <Route element={<UserLayout footerHide="footer-hider" initialData={initialData} />}>
          <Route path="404" element={<Error />} />
          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="thankyou" element={<Thankyou />} />
        </Route>
      </Routes>
      </Suspense>
    </>
  )
}
